(function () {
  'use strict';

  /* Mobile menu */
  function initMenu() {
    var toggle = document.querySelector('[data-menu-open]');
    var menu = document.getElementById('MobileMenu');
    if (!toggle || !menu) return;
    var close = menu.querySelector('[data-menu-close]');

    function open() {
      menu.hidden = false;
      toggle.setAttribute('aria-expanded', 'true');
      document.body.style.overflow = 'hidden';
      if (close) close.focus();
    }
    function shut() {
      menu.hidden = true;
      toggle.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
      toggle.focus();
    }
    toggle.addEventListener('click', open);
    if (close) close.addEventListener('click', shut);
    menu.addEventListener('keydown', function (e) { if (e.key === 'Escape') shut(); });
    menu.querySelectorAll('a').forEach(function (a) {
      a.addEventListener('click', function () {
        menu.hidden = true;
        document.body.style.overflow = '';
      });
    });
  }

  /* Tabs (memberships) */
  function initTabs(root) {
    root.querySelectorAll('[data-tabs]').forEach(function (tabs) {
      var buttons = Array.prototype.slice.call(tabs.querySelectorAll('[role="tab"]'));
      function select(btn) {
        buttons.forEach(function (b) {
          var on = b === btn;
          b.setAttribute('aria-selected', on ? 'true' : 'false');
          b.tabIndex = on ? 0 : -1;
          var panel = document.getElementById(b.getAttribute('aria-controls'));
          if (panel) panel.hidden = !on;
        });
      }
      buttons.forEach(function (btn, i) {
        btn.addEventListener('click', function () { select(btn); });
        btn.addEventListener('keydown', function (e) {
          var next = null;
          if (e.key === 'ArrowRight') next = buttons[(i + 1) % buttons.length];
          if (e.key === 'ArrowLeft') next = buttons[(i - 1 + buttons.length) % buttons.length];
          if (next) { e.preventDefault(); select(next); next.focus(); }
        });
      });
    });
  }

  /* Variant picker */
  function formatMoney(cents, format) {
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    var withDecimals = parts.join('.');
    var noDecimals = parts[0];
    format = format || '£{{amount}}';
    return format
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, noDecimals)
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, withDecimals.replace('.', ','))
      .replace(/\{\{\s*amount\s*\}\}/, withDecimals);
  }

  function initVariantPickers(root) {
    root.querySelectorAll('[data-variant-picker]').forEach(function (picker) {
      var dataEl = picker.querySelector('script[type="application/json"]');
      if (!dataEl) return;
      var variants = JSON.parse(dataEl.textContent);
      var form = picker.closest('form');
      var select = form.querySelector('select[name="id"]');
      var priceEl = document.querySelector(picker.getAttribute('data-price-target'));
      var button = form.querySelector('[type="submit"]');
      var moneyFormat = picker.getAttribute('data-money-format');
      var soldOutLabel = button ? button.getAttribute('data-sold-out') : 'Sold out';
      var addLabel = button ? button.getAttribute('data-add') : 'Add to basket';

      picker.classList.remove('no-js-hidden');
      if (select) select.closest('.no-js-select').hidden = true;

      function current() {
        var chosen = [];
        picker.querySelectorAll('fieldset').forEach(function (fs) {
          var checked = fs.querySelector('input:checked');
          chosen.push(checked ? checked.value : null);
        });
        return variants.find(function (v) {
          return v.options.every(function (opt, i) { return opt === chosen[i]; });
        });
      }

      function update() {
        var v = current();
        if (!v) {
          if (button) { button.disabled = true; button.textContent = 'Unavailable'; }
          return;
        }
        if (select) select.value = v.id;
        if (button) {
          button.disabled = !v.available;
          button.textContent = v.available ? addLabel : soldOutLabel;
        }
        if (priceEl) {
          var html = '';
          if (v.compare_at_price && v.compare_at_price > v.price) {
            html += '<s>' + formatMoney(v.compare_at_price, moneyFormat) + '</s>';
          }
          html += formatMoney(v.price, moneyFormat);
          priceEl.innerHTML = html;
        }
        if (window.history && window.history.replaceState && picker.hasAttribute('data-update-url')) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', url.toString());
        }
      }

      picker.addEventListener('change', update);
      update();
    });
  }

  /* Hero video: pause control, respects reduced motion */
  function initHeroVideo(root) {
    root.querySelectorAll('[data-hero-pause]').forEach(function (btn) {
      var video = btn.parentElement.querySelector('video');
      if (!video) return;
      var label = btn.querySelector('.hero__pause-label');
      function setState(paused) {
        btn.setAttribute('aria-pressed', paused ? 'true' : 'false');
        if (label) label.textContent = paused ? 'Play video' : 'Pause video';
      }
      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        video.removeAttribute('autoplay');
        video.pause();
        setState(true);
      } else {
        var p = video.play();
        if (p && p.catch) p.catch(function () { setState(true); });
      }
      btn.addEventListener('click', function () {
        if (video.paused) { video.play(); setState(false); } else { video.pause(); setState(true); }
      });
    });
  }

  function init(root) {
    initHeroVideo(root);
    initTabs(root);
    initVariantPickers(root);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initMenu();
    init(document);
  });

  /* Theme editor support */
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
